/* Load each app at its point of use. No general-purpose script interception. */
(() => {
  if (window.MASApps) return;
  const loaded = new Map();
  const reviewTarget = '.jdgm-review-widget,.jdgm-all-reviews-widget,.jdgm-all-reviews-page,.jdgm-carousel,.jdgm-ugc-media,.jdgm-cards-carousel,.jdgm-videos-carousel';
  let reviewObserver;
  const loadScript = (key, src) => {
    if (loaded.has(key)) return loaded.get(key);
    const task = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.masLoadedApp = key;
      const timer = setTimeout(() => fail(), 20000);
      const fail = () => {
        clearTimeout(timer);
        script.remove();
        loaded.delete(key);
        reject(new Error('Unable to load ' + key));
      };
      script.onload = () => { clearTimeout(timer); resolve(); };
      script.onerror = fail;
      document.head.appendChild(script);
    });
    loaded.set(key, task);
    return task;
  };
  const loadReviews = () => {
    if (window.Shopify?.designMode) return Promise.resolve();
    const entry = document.querySelector('script[src*="/judgeme-"][src*="/assets/loader.js"]');
    if (!entry) return Promise.resolve();
    if (window.jdgm?._blocked) return Promise.reject(new Error('Reviews unavailable on this hostname'));
    if (!loaded.has('reviews')) {
      window.jdgm = window.jdgm || {};
      window.jdgm._loaderExecuted = false;
    }
    const task = loadScript('reviews', entry.src);
    task.then(() => { entry.dataset.loaded = 'true'; }).catch(() => {});
    return task;
  };
  const loadRewards = () => {
    const config = document.querySelector('[data-mas-deferred-app="rewards"]');
    if (!config) return Promise.resolve();
    if (!config.dataset.channelKey) {
      document.dispatchEvent(new CustomEvent('mas:rewards-unavailable'));
      return Promise.reject(new Error('Smile channel configuration is missing'));
    }
    // Smile's extension loader only listens to window.load; use its same entry
    // point directly so a click after that event can initialise the app.
    return loadScript('rewards', 'https://js.smile.io/v1/smile-shopify.js?shop=' + encodeURIComponent(window.Shopify.shop));
  };
  window.MASApps = { loadReviews, loadRewards };
  const start = () => {
    if ('IntersectionObserver' in window) {
      reviewObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        reviewObserver.disconnect();
        loadReviews().catch(() => {});
      }, { rootMargin: '600px 0px' });
      document.querySelectorAll(reviewTarget).forEach(node => reviewObserver.observe(node));
    } else loadReviews().catch(() => {});
    // Honour review request emails and rewards deep links on direct navigation.
    if (/judgeme|jdgm/.test(location.hash + location.search)) loadReviews().catch(() => {});
    if (location.hash.startsWith('#smile-')) loadRewards().catch(() => {});
    const rewards = document.querySelector('[data-mas-programs="rewards"]');
    if (rewards && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect(); loadRewards().catch(() => {});
        }
      }, { rootMargin: '300px 0px' });
      observer.observe(rewards);
    }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest?.('a,button,.jdgm-prev-badge');
    if (!target) return;
    if (target.matches('[data-pdp-jump="reviews"],[data-mas-reviews],.jdgm-prev-badge') || target.getAttribute('aria-label') === 'See all reviews' || target.closest(reviewTarget)) loadReviews().catch(() => {});
    if (target.getAttribute('href')?.startsWith('#smile-')) loadRewards().catch(() => {});
  }, true);
  document.addEventListener('focusin', event => {
    if (event.target.closest?.(reviewTarget + ',.jdgm-prev-badge,[data-pdp-jump="reviews"]')) loadReviews().catch(() => {});
  });
  addEventListener('hashchange', () => {
    if (location.hash.startsWith('#smile-')) loadRewards().catch(() => {});
    if (/judgeme|jdgm/.test(location.hash)) loadReviews().catch(() => {});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
